module.exports = __webpack_public_path__ + "img/facebook.4a20d66f.png";